import L from "leaflet";
import { Marker, Popup, Tooltip } from "react-leaflet";
import MarineLantern from  "../../../images/Icons/V2/MarineLantern.svg"
import HelihoistLight from  "../../../images/Icons/V2/HelihoistLight.svg"
import HelihoistLightWithSRO from  "../../../images/Icons/V2/HelihoistLightWithSRO.svg"
import VisibilitySensor from  "../../../images/Icons/V2/VisibilitySensor.svg"
import MarineVisibilitySensor from  "../../../images/Icons/V2/MarineVisibilitySensor.svg"
import Foghorn from  "../../../images/Icons/V2/Foghorn.svg"
import MarineRadio from  "../../../images/Icons/V2/MRASS.svg"
import AIS from  "../../../images/Icons/V2/AIS.svg"

import MarineLantern5nm from  "../../../images/Icons/V2/MarineLantern5NM.svg"
import MarineLantern3nm from  "../../../images/Icons/V2/MarineLantern3NM.svg"
import MarineLantern2nm from  "../../../images/Icons/V2/MarineLantern2NM.svg"
import HeliCorridorLights from  "../../../images/Icons/V2/HelicopterCorridorLights.svg"
import BoatLandingLight from  "../../../images/Icons/V2/BoatLandingLight.svg"
import AviationObstructionLightLowIntensity from  "../../../images/Icons/V2/AviationObstructionLightLowIntensity.svg"
import Racon from  "../../../images/Icons/V2/RACON.svg"
import TowerObstructionLight from "../../../images/Icons/V2/TowerObstructionLight.svg";

// Version 1
import VisibilitySensorIconOrange from  "../../../images/SVG/Ring2.svg"



import VisibilitySensorIconPurple from  "../../../images/SVG/Ring2Purple.svg"
// import HeliCorridorLights from  "../../../images/Icons/HeliCorridorLights.svg"
// import MarineRadio from  "../../../images/Icons/MarineRadio.svg"
// import AisKitNasT3 from  "../../../images/Icons/AIS_KitNasT3svg.svg"
import VisibilitySensorIconBlue from  "../../../images/SVG/Ring2Blue.svg"

import { Grid, Button } from "@mui/material";
import { NavLink } from "react-router-dom";

import { select } from "../../../features/WTG/TurbineSlice";
import { useDispatch } from "react-redux";



const IconCircleFunction = () => {
   
    const color = "#0473b8";

    return (
        
      <svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1080">
        <rect
          width="100%"
          height="100%"
          x="0"
          y="0"
          fill="none"
          stroke="none"
        ></rect>
        <g className="currentLayer">
          <rect width="100%" height="100%" x="0" y="0" fill="transparent"></rect>
          <g>
            <rect
              width="1080"
              height="1080"
              x="-540"
              y="-540"
              fill="#FFF"
              fillRule="nonzero"
              stroke="none"
              strokeDasharray="none"
              strokeDashoffset="0"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeMiterlimit="4"
              strokeWidth="1"
              opacity="1"
              rx="0"
              ry="0"
              transform="translate(540 540)"
              vectorEffect="non-scaling-stroke"
              visibility="hidden"
            ></rect>
          </g>
          <g fill={color} fillOpacity="1" className="selected">
            <circle
              cx="0"
              cy="0"
              r="35"
              fill={color} 
              fillOpacity="1"
              fillRule="nonzero"
              stroke="#000"
              strokeDasharray="none"
              strokeDashoffset="0"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeMiterlimit="4"
              strokeWidth="0"
              opacity="1"
              transform="matrix(12.4 0 0 12.4 540 540)"
              vectorEffect="non-scaling-stroke"
            ></circle>
          </g>
        </g>
      </svg>
    );
  }
  
  let iconSize = [32,32]
  let iconsENSORSize = [35,35]
  let iconSpecialSize = [35,35]


  /// NNJNJNJn
  var TowerRedDotWithX = L.icon({
    iconUrl: TowerObstructionLight,
    iconSize: iconSize,
    
  });


var HelihoistIcon = L.icon({
    iconUrl: HelihoistLight,
    iconSize: iconSize,

});
var HelihoistWithSROIcon = L.icon({
    iconUrl: HelihoistLightWithSRO,
    iconSize: iconSize,

});
var MarineLantern_Icon = L.icon({
    iconUrl: MarineLantern,
    iconSize: [iconSize[0],iconSize[1]],
});
var MarineLantern5nm_Icon = L.icon({
    iconUrl: MarineLantern5nm,
    iconSize: [iconSize[0],iconSize[1]],
});
var MarineLantern3nm_Icon = L.icon({
    iconUrl: MarineLantern3nm,
    iconSize: [iconSize[0],iconSize[1]],
});var MarineLantern2nm_Icon = L.icon({
    iconUrl: MarineLantern2nm,
    iconSize: [iconSize[0],iconSize[1]],
});


var VisibilitySensor_Icon = L.icon({
    iconUrl: VisibilitySensor,
    iconSize: iconsENSORSize,
});
var MarineVisibilitySensor_Icon = L.icon({
    iconUrl: MarineVisibilitySensor,
    iconSize: iconsENSORSize,
});
var FogHornIcon = L.icon({
    iconUrl: Foghorn,
    iconSize: iconSpecialSize,
});
var AISIcon = L.icon({
    iconUrl: AIS,
    iconSize: iconsENSORSize,
});

var MarineRadioIcon = L.icon({
    iconUrl: MarineRadio,
    iconSize: iconSpecialSize,
});
var RaconIcon = L.icon({
    iconUrl: Racon,
    iconSize: iconsENSORSize,
});
var HeliCorridorLightsIcon = L.icon({
    iconUrl: HeliCorridorLights,
    iconSize: iconsENSORSize,

});var BoatLandingLightIcon = L.icon({
    iconUrl: BoatLandingLight,
    iconSize: iconsENSORSize,
});



export const DisplayOSS = (turbine) => {
    let OSSIcon = L.icon({
        iconUrl: BoatLandingLight,
        iconSize: iconsENSORSize,
    });
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={OSSIcon}
        zIndexOffset={1000} 
    >
    </Marker>
}



export const DisplayTowerRedDotWithX = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={TowerRedDotWithX}
        zIndexOffset={1000} 
    >
    </Marker>
}
export const DisplayRacon = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={RaconIcon}
        zIndexOffset={1000} 
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >

    </Marker>
}
export const DisplayBoatLandingLight = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={BoatLandingLightIcon}
        zIndexOffset={1000} 
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >

    </Marker>
}


// var HeliCorridorLightsIcon = L.icon({
//     iconUrl: HeliCorridorLights,
//     iconSize: [20, 20],
//     forceZIndex: 1000
// });


// const BS = 15;
// var AisKitNasT3Icon = L.icon({
//     iconUrl: AisKitNasT3,
//     iconSize: [BS, BS],
//     zIndexOffset: 1
// });




export const DisplayMarineLantern3NM = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={MarineLantern3nm_Icon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >
    
    </Marker>
}
export const DisplayMarineLantern2NM = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={MarineLantern2nm_Icon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >
    
    </Marker>
}

export const DisplayMarineLantern5NM = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={MarineLantern5nm_Icon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >

    </Marker>
}

// Zoom 13 er ca. *.6 mindre 

export const DisplayMarineHelicopterCorridorLights = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={HeliCorridorLightsIcon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked: ' + turbine.name)
            },
        }}
    >

    </Marker>
}

export const DisplayMarineRadio = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}

        icon={MarineRadioIcon}
        zIndexOffset={1000}
        eventHandlers={{
            click: () => {
                console.log('marker clicked: ' + turbine.name)
            },
        }}
    >

    </Marker>
}

export const DisplayAisKitNasT3 = (turbine) => {
    // return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
    //     icon={AisKitNasT3Icon}
    //     eventHandlers={{
    //         click: () => {
    //             // console.log('marker clicked')
    //         },
    //     }}
    // >

    // </Marker>
}

export const DisplayAIS = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={AISIcon}
        zIndexOffset={1100} 

        eventHandlers={{
            click: () => {
                console.log('marker clicked: ' + turbine.name)
            },
        }}
    >

    </Marker>
}

export const DisplayFogHorn = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={FogHornIcon}
        zIndexOffset={1100} 

        eventHandlers={{
            click: () => {
                console.log('marker clicked: ' + turbine.name)
                  
            },
        }}
    >

    </Marker>
}


export const DisplayVisibilitySensor = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={VisibilitySensor_Icon}
        zIndexOffset={1100} 
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >

    </Marker>
}
export const DisplayMarineVisibilitySensor = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={MarineVisibilitySensor_Icon}
        zIndexOffset={1100} 
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >

    </Marker>
}




export const DisplayHelihoistLightWithSRO = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={HelihoistWithSROIcon}
        zIndexOffset={1200} 
        eventHandlers={{
            click: () => {
                console.log('marker clicked123123')
            },
        }}
    >
             <PopUP turbine={turbine}></PopUP>

    </Marker>
}

export const DisplayHelihoistLight = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={HelihoistIcon}
        zIndexOffset={1100} 
        eventHandlers={{
            click: () => {
                console.log('marker clicked123')
            },
        }}
    >
        
        <PopUP turbine={turbine}></PopUP>
    </Marker>
}



// Version 1




var SPSIcon = L.icon({
    iconUrl: VisibilitySensorIconOrange,
    iconSize: [27, 27],
    zIndexOffset: 10000
});

var IPSIcon = L.icon({
    iconUrl: VisibilitySensorIconPurple,
    iconSize: [27, 27],
    zIndexOffset: 10000
});

var PSIcon = L.icon({
    iconUrl: VisibilitySensorIconBlue,
    iconSize: [27, 27],
    zIndexOffset: 10000
});


export const DisplayPsIcon = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={PSIcon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >
        
    </Marker>
}

export const DisplayIpsIcon = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={IPSIcon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >
    
    </Marker>
}


export const DisplaySpsIcon = (turbine) => {
    return <Marker position={[Number(turbine.lat), Number(turbine.long)]}
        icon={SPSIcon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >

    </Marker>
}

export const IPSIconDisplay = (turbine) => {
    return <Marker position={[Number(turbine.lat)-0.0009, Number(turbine.long)-0.006]}
        icon={IPSIcon}
        eventHandlers={{
            click: () => {
                console.log('marker clicked')
            },
        }}
    >
        <Tooltip>
            {turbine.name} <br />
        </Tooltip>
    </Marker>
}

const PopUP = (value) => {
    const dispatch = useDispatch();

    // console.log(JSON.stringify(turbine))
    const turbine = value.turbine;
    return<Popup>
<Grid container>

  Name: {turbine.name} <br />
  Lat: {turbine.lat} <br />
  Long: {turbine.long}<br />
  Type: {turbine.type}<br />

</Grid>
<Grid container marginTop={"10px"}
  justifyContent="center">
  <NavLink
    style={{ textDecoration: 'none' }}
    to="/wtg">
    <Button size="small"
      onClick={() => {
        console.log("click: " + turbine.name)
        dispatch(select(value))
      }
      } variant="outlined" style={{backgroundColor:"#263238", color:"White"}}>see more</Button>
  </NavLink>
</Grid>
</Popup>
}
